import request from "@/utils/request";
import type { DeckResult, PvpCardGameProfile } from "./type";
import type { PageParams, PageRes } from "@/types";

export function getPvpCardProfileApi() {
  return request<PvpCardGameProfile>({
    url: "pvp-card/profile",
    headers: {
      noMessage: true,
    },
  });
}

export function getFreeCardPackApi() {
  return request<DeckResult>({
    url: "pvp-card/freeCardPack",
    headers: {
      noMessage: true,
    },
  });
}

export function getWinsCardPackApi() {
  return request<DeckResult>({
    url: "pvp-card/winsCardPack",
    headers: {
      noMessage: true,
    },
  });
}

export function upgradeCardApi(cardId: number) {
  return request<{ duelCoin: number; needCount: number; level: number }>({
    url: "pvp-card/upgradeCard",
    method: "POST",
    data: {
      cardId,
    },
    headers: {
      noMessage: true,
    },
  });
}

export function useCardApi(body: {
  cardId: number;
  deckIndex: number;
  action: string;
}) {
  return request<{ message: string }>({
    url: "pvp-card/useCard",
    method: "POST",
    data: body,
    headers: {
      noMessage: true,
    },
  });
}

export function changeCurrentDeckApi(body: { currentDeck: number }) {
  return request<{ message: string }>({
    url: "pvp-card/changeCurrentDeck",
    method: "POST",
    data: body,
    headers: {
      noMessage: true,
    },
  });
}

export function openCardPackApi(params: { index: number }) {
  return request<DeckResult>({
    url: "pvp-card/openCardPack",
    method: "GET",
    params,
    headers: {
      noMessage: true,
    },
  });
}

export function getGameRecordApi(params: PageParams) {
  return request<PageRes<any[]>>({
    url: "pvp-card/gameRecord",
    method: "GET",
    params,
    headers: {
      noMessage: true,
    },
  });
}

export function getSeasonRankApi(params: PageParams) {
  return request<PageRes<PvpCardGameProfile[]>>({
    url: "pvp-card/seasonRank",
    method: "GET",
    params,
    headers: {
      noMessage: true,
    },
  });
}

export function getExpRankApi(params: PageParams) {
  return request<PageRes<PvpCardGameProfile[]>>({
    url: "pvp-card/expRank",
    method: "GET",
    params,
    headers: {
      noMessage: true,
    },
  });
}

export function getRecentLoseStreakApi() {
  return request<number>({
    url: "pvp-card/recentLoseStreak",
    method: "GET",
    headers: {
      noMessage: true,
    },
  });
}
